import PropTypes from "prop-types";
import React from "react";

import { withScreenContext } from "../../components/screen/ScreenContext";
import { isScreenModeMobile } from "../../constants/screenModes";
import DesktopToolbar from "./Toolbar.desktop";
import HarvardMobileToolbar from "./Toolbar.harvard.mobile";

const HarvardToolbar = props =>
  isScreenModeMobile(props.screenContext.screenMode) ? (
    <HarvardMobileToolbar {...props} />
  ) : (
    <DesktopToolbar {...props} />
  );

HarvardToolbar.propTypes = {
  screenContext: PropTypes.object
};

export default withScreenContext(HarvardToolbar);
